export const env = {
    "environment": "prd",
    "frontDoorUrl": "https://connect.bender-group.com",
    "academyUrl": "https://academy.bender.de",
    "seminarsUrl": "https://academy.connect.bender-group.com/en/seminars",
    "powerscoutUrl": "https://powerscout.connect.bender-group.com",
    "extranetUrl": "https://extranet.connect.bender-group.com",
    "ticketSystemUrl": "https://connect.bender-group.com/service/ticket-system/",
    "systemAdministratorUrl": "https://connect.bender-group.com/system-administrator/",
    "filesDocumentsUrl": "https://connect.bender-group.com/files-documents/"
};
//# sourceMappingURL=env.js.map